// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider-button {
  height: 46px;
  width: 100% !important;
}
.slider-button input {
  height: 46px;
}
.slider-button input[type=range] {
  appearance: none; /* Hides the slider so that custom slider can be made */
  -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
  width: 100%; /* Specific width is required for Firefox. */
  background: transparent; /* Otherwise white in Chrome */
  background-color: var(--vl-red);
  border-radius: 50px !important;
  transition: 0.25s background-color;
}
.slider-button input[type=range]::-ms-track {
  width: 100%;
  cursor: pointer;
  border-color: transparent;
  color: transparent;
  height: 46px;
  width: 46px;
  color: #2dd36f;
  background-color: cyan;
  -ms-transition: 1s all;
  transition: 1s all;
}
.slider-button input[type=range]::-moz-range-track {
  background: none;
  border-color: transparent;
  color: transparent;
}
.slider-button input[type=range]::-moz-range-thumb {
  appearance: none;
  -webkit-appearance: none;
  border: 1px solid var(--vl-red);
  background: #F8F8FE;
  position: relative;
  bottom: 14px;
  z-index: 1;
  cursor: pointer;
  border-radius: 50px;
  height: 46px;
  width: 46px;
  -moz-transition: 1s all;
  transition: 1s all;
}
.slider-button input[type=range]::-webkit-slider-runnable-track {
  background: none;
  border-color: transparent;
  color: transparent;
}
.slider-button input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  border: 1px solid var(--vl-red);
  background: #F8F8FE;
  position: relative;
  bottom: 14px;
  z-index: 1;
  cursor: pointer;
  border-radius: 50px;
  height: 46px;
  width: 46px;
  -webkit-transition: 1s all;
  transition: 1s all;
}
.slider-button input[type=range].dark {
  background-color: var(--vl-black-font);
}
.slider-button input[type=range].dark::-webkit-slider-thumb {
  border: 1px solid var(--vl-black-font);
}

.slider-button {
  position: relative;
}
.slider-button .form-range {
  width: 100%;
  height: 46px;
  appearance: none;
  background: var(--vl-red);
  border-radius: 50px;
  position: relative;
  z-index: 1;
}
.slider-button .slider-label {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  pointer-events: none;
  font-size: 1rem;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/elements/slider-button/slider-button.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,sBAAA;AACF;AACE;EACE,YAAA;AACJ;AAEE;EACE,gBAAA,EAAA,uDAAA;EACA,wBAAA,EAAA,uDAAA;EACA,WAAA,EAAA,4CAAA;EACA,uBAAA,EAAA,8BAAA;EAEA,+BAAA;EACA,8BAAA;EACA,kCAAA;AADJ;AAII;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;EACA,sBAAA;EAAA,kBAAA;AAFN;AAKI;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;AAHN;AAMI;EACE,gBAAA;EACA,wBAAA;EACA,+BAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EAAA,kBAAA;AAJN;AAOI;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;AALN;AAQI;EACE,wBAAA;EACA,+BAAA;EACA,mBAAA;EACA,kBAAA;EAEA,YAAA;EACA,UAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EAAA,kBAAA;AAPN;AAUI;EACE,sCAAA;AARN;AAUM;EACE,sCAAA;AARR;;AAcA;EACE,kBAAA;AAXF;AAaE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AAXJ;AAcE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,UAAA;AAZJ","sourcesContent":[".slider-button {\n  height: 46px;\n  width: 100% !important;\n\n  input {\n    height: 46px;\n  }\n\n  input[type=range] {\n    appearance: none; /* Hides the slider so that custom slider can be made */\n    -webkit-appearance: none; /* Hides the slider so that custom slider can be made */\n    width: 100%; /* Specific width is required for Firefox. */\n    background: transparent; /* Otherwise white in Chrome */\n\n    background-color: var(--vl-red);\n    border-radius: 50px !important;\n    transition: .25s background-color;\n\n\n    &::-ms-track {\n      width: 100%;\n      cursor: pointer;\n      border-color: transparent;\n      color: transparent;\n      height: 46px;\n      width: 46px;\n      color: #2dd36f;\n      background-color: cyan;\n      transition: 1s all;\n    }\n\n    &::-moz-range-track {\n      background: none;\n      border-color: transparent;\n      color: transparent;\n    }\n\n    &::-moz-range-thumb {\n      appearance: none;\n      -webkit-appearance: none;\n      border: 1px solid var(--vl-red);\n      background: #F8F8FE;\n      position: relative;\n      bottom: 14px;\n      z-index: 1;\n      cursor: pointer;\n      border-radius: 50px;\n      height: 46px;\n      width: 46px;\n      transition: 1s all;\n    }\n\n    &::-webkit-slider-runnable-track {\n      background: none;\n      border-color: transparent;\n      color: transparent;\n    }\n\n    &::-webkit-slider-thumb {\n      -webkit-appearance: none;\n      border: 1px solid var(--vl-red);\n      background: #F8F8FE;\n      position: relative;\n      // top: 0px;\n      bottom: 14px;\n      z-index: 1;\n      cursor: pointer;\n      border-radius: 50px;\n      height: 46px;\n      width: 46px;\n      transition: 1s all;\n    }\n\n    &.dark {\n      background-color: var(--vl-black-font);\n\n      &::-webkit-slider-thumb {\n        border: 1px solid var(--vl-black-font);\n      }\n    }\n  }\n}\n\n.slider-button {\n  position: relative;\n\n  .form-range {\n    width: 100%;\n    height: 46px;\n    appearance: none;\n    background: var(--vl-red);\n    border-radius: 50px;\n    position: relative;\n    z-index: 1;\n  }\n\n  .slider-label {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 100%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n    color: white;\n    pointer-events: none;\n    font-size: 1rem;\n    z-index: 2;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
